import React from "react";
import { ContentUnavailableModalTemplate } from "themes/application/common/components";

function ContentUnavailableModal(props) {
    return <ContentUnavailableModalTemplate {...props} />;
}

export default ContentUnavailableModal;
